export default __webpack_public_path__ + "static/media/Body.30ad8476.mp3";